module.exports = __webpack_public_path__ + "static/media/tecblic_logo.e691e489.png";